module.exports = __webpack_public_path__ + "h5/img/pkback.dc54eaee.jpg";